/** Hidden tabs must not hold a Vercel SSE function or reconnect-storm Redis. */
export function isDocumentVisibleForLive(visibilityState) {
  return visibilityState !== 'hidden';
}
